import React from 'react';
import axios from 'axios';
import { Link } from "react-router-dom";

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    //console.log(this.props.match.params);
    //console.log(props);
    this.state = {dataSent: [],error: ''};
  }
  componentDidMount() {
    var data = new FormData();
    data.append('pagination', 1);
    //alert(this.props.pagination);
    axios.post('../post.php', data)
    .then(result => {
        console.log(result.data[0].ile)
        this.setState({
            dataSent: result.data,
        })
        console.log(this.state)
    })
    .catch(error => this.setState({
        error: error.message
    }));
  }
  render() {
    let datapages = Number(this.state.dataSent[0]?.ile);
    let pagesarray = [];
    if(datapages) {
      let pages = Math.ceil(datapages/10);
      for(let i=1;i<=pages;i++){
        pagesarray[i-1] = i;
      }
    }
    console.log(this.state);
    return (
      pagesarray.map(d => (
        <span>
        <Link
          to={`/posts/${d}`}
          key={d}
        >
          {d}
        </Link>
        {' '}
        </span>
      ))
    );
  }
}

export default Pagination;
